import { Button, type ButtonProps, Menu, MenuButton, MenuList } from '@chakra-ui/react'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import { SAT_BOOTCAMP_ONBOARDING_TEMPLATE_SLUG } from '@/queries/constants'
import SeriesQ from '@/queries/SeriesQ'
import type { Query } from '@/client/query'
import { getMonthlyProgramSeriesTemplateSwitchLimit } from '@/client/services/programs/helpers'
import { getSATOnboardingSessionsUrl } from '@/client/services/url'

import SeriesWithdrawButton from '@/components/Series/SeriesWithdrawButton'

export default function RegisteredButton({
  series,
  ...props
}: { series: Query } & ButtonProps): ReactElement {
  const seriesId = series(SeriesQ.id) ?? 0

  const hasSeriesEnded = series(SeriesQ.hasEnded()) ?? true

  const seriesTemplateSlug = series(SeriesQ.getSeriesTemplateSlug())
  const isSATBootcampOnboardingSeries = seriesTemplateSlug === SAT_BOOTCAMP_ONBOARDING_TEMPLATE_SLUG
  const monthlySwitchLimit = getMonthlyProgramSeriesTemplateSwitchLimit(seriesTemplateSlug ?? '')

  return (
    <Menu closeOnSelect={false} placement="bottom-end">
      <MenuButton
        as={Button}
        variant="outline"
        color="fg.muted"
        aria-label="See options"
        rightIcon={
          <FontAwesomeIcon icon={faChevronDown} color={chakraTokenToVar('fg.muted')} size="xs" />
        }
        {...props}
      >
        Registered
      </MenuButton>
      <MenuList
        bg="bg"
        border={`2px solid ${chakraTokenToVar('border.emphasized')}`}
        borderRadius="5px"
      >
        <SeriesWithdrawButton
          seriesId={seriesId}
          isMenuItem
          isDisabled={hasSeriesEnded}
          monthlySwitchLimit={monthlySwitchLimit}
          redirectTo={isSATBootcampOnboardingSeries ? getSATOnboardingSessionsUrl() : null}
        />
      </MenuList>
    </Menu>
  )
}
